import React, { useCallback } from 'react';

import useCurrencyFormatter from '~/components/CurrencyFormatterContext';

export const useFormatAmount = () => {
  const { currencyFormatter } = useCurrencyFormatter();
  return useCallback(
    (amount: number | string) => {
      const amountNumber = typeof amount === 'string' ? parseFloat(amount) : amount;
      return currencyFormatter.format(amountNumber);
    },
    [currencyFormatter]
  );
};

export const AmountValueDisplay = ({ amount }: { amount: number | string }) => {
  const formatAmount = useFormatAmount();
  return <>{formatAmount(amount)}</>;
};
